import makeStyles from '@material-ui/core/styles/makeStyles';
import { NAVY_BLUE, ORANGE_PRIMARY } from '../../../utils/colors/colors.contants';

export default makeStyles({
  dialog__root: {
    '& .MuiDialog-paperWidthSm': {
      width: '585px',
      maxWidth: '62.5rem',
    },
    '& .MuiDialogContent-root:first-child': {
      padding: '2.1875rem 5.75rem 2.1875rem 5.75rem',
    },
  },
  dialog__textContainer: {
    whiteSpace: 'break-spaces',
    textAlign: 'left',
    color: NAVY_BLUE,
    '& h2': {
      fontSize: '1.875rem',
      fontWeight: 'bold',
    },
    '& p': {
      width: '420px',
      fontSize: '16px',
    },
    '@media screen and (max-width: 585px)': {
      '& h2': {
        fontSize: '1rem',
      },
      '& p': {
        fontSize: '16px',
      },
      padding: '0 2.1875rem',
    },
  },
  dialog__icon: {
    display: 'inline-flex',
    width: '100%',
    maxHeight: '6.25rem',
    justifyContent: 'center',
    padding: '2rem',
  },
  dialog__icon__sucess: {
    '& .MuiSvgIcon-root': {
      fontSize: '5.5rem',
      color: 'green',
      '@media screen and (max-width: 600px)': {
        fontSize: '3rem',
      },
    },
  },
  dialog__icon__error: {
    '& .MuiSvgIcon-root': {
      fontSize: '5.5rem',
      color: ORANGE_PRIMARY,
      '@media screen and (max-width: 600px)': {
        fontSize: '3rem',
      },
    },
  },
  dialog__actions: {
    justifyContent: 'right',
  },
});
